import { RoundedBox, useTelemetry } from "@knowfully/ui.common";
import { useIntl } from "react-intl";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  SxProps,
  Typography,
} from "@mui/material";
import { useEffect } from "react";

const styles: { [key: string]: SxProps } = {
  accordionBox: {
    px: 0,
    py: 1,
  },
  accordion: {
    boxShadow: "none",
    textAlign: "left",
  },
  accordionSummary: {
    flexDirection: "row-reverse",
  },
  accordionDetails: {
    py: 0,
  },
};

const ErrorPage = () => {
  const { formatMessage: t } = useIntl();
  const telemetry = useTelemetry();
  const queryParams = new URLSearchParams(window.location.search);

  const operationId = queryParams.get("operationId");

  useEffect(() => {
    const errorObj = new Error("User reached error page in facultyportal");
    telemetry.trackException(errorObj, {
      url: window.location.href,
      operationId: operationId,
      loggedFrom: "ErrorPage",
    });
  }, [operationId, telemetry]);

  return (
    <Grid
      container
      display="flex"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      direction="column"
    >
      <Grid item xs={12} md={6}>
        <RoundedBox>
          <Typography variant="h4" gutterBottom>
            {t({ id: "sorryPageNotAvailable" })}
          </Typography>
          <Typography variant="body1">
            {t({ id: "tryAgainLater" })}
          </Typography>
        </RoundedBox>
        {!!operationId && (
          <RoundedBox sx={styles.accordionBox}>
            <Accordion sx={styles.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="details-content"
                id="details-header"
                sx={styles.accordionSummary}
              >
                <Typography variant="body1">{t({ id: "details" })}</Typography>
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                {operationId && (
                  <Typography variant="body2">
                    {t({ id: "operationId" })}: {operationId}
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </RoundedBox>
        )}
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
